<template>
  <div>
    <b-table :fields="fields" :items="$store.getters.attachedFiles">
      <span slot="file" slot-scope="data" v-html="data.value"></span>
      <template slot="delLink" slot-scope="environment">
        <b-button @click="deleteDialog(environment.item.filename)" size="sm" variant="danger">X</b-button>
      </template>
    </b-table>

    <b-modal ref="confirmDelete" title="Skutečne smazat??">
      <template slot="modal-footer">
        <b-button size="sm" variant="danger" @click="delFile()">Smazat</b-button>
        <b-button size="sm" variant="success" @click="$refs['confirmDelete'].hide()">Zrušit</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  name: 'files',
  props: {
    peopleDetail: {},
    showDeleteBtn: null
  },
  components: {
  },
  data: () => ({
    peopleID: null,
    fileForDelete: null,
    fields: [
      { key: 'filename', label: 'Název souboru' },
      { key: 'file', label: 'Soubor' },
      { key: 'size', label: 'Velikost' },
      { key: 'delLink', label: 'Smazat' }
    ]

  }),
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.peopleID = this.$route.params.id
    } else {
      this.peopleID = this.peopleDetail.id
    }

    this.loadFiles()
  },
  methods: {
    deleteDialog (file) {
      this.$refs['confirmDelete'].show()
      this.fileForDelete = file
    },
    delFile () {
      axios
        .delete(`/api/v1/people/${this.peopleID}/attachment/${this.fileForDelete}`)
        .then(response => {
          this.loadFiles()
          this.$refs['confirmDelete'].hide()
        })
        .catch(response => {
          console.log('deleteError')
          console.log(response.data)
        })
    },
    loadFiles () {
      axios
        .get(`/api/v1/people/${this.peopleID}/attachment`)
        .then(response => {
          let formatedData = []
          let peopleID = this.peopleID

          let deleteBtn = this.showDeleteBtn
          response.data.forEach(function (data) {
            formatedData.push({
              date: new Date((data.time)).toLocaleDateString(),
              filename: data.filename,
              size: `${Math.round(data.size / 1024)} kB`,
              file: `<a href="api/v1/people/${peopleID}/attachment/${data.filename}"> 
            <img width="30px" height="30px" src="/api/v1/icon/${data.icon}"/> </a>`,
              delLink: ``
            })
          })
          this.$store.commit('attachedFiles', formatedData)
        })
        .catch(response => {
          console.log('loadFiles Error: ' + response)
        })
    }

  }
})
</script>
